import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';

function WelcomeNote() {
  const user = useSelector((state: RootState) => state?.user?.user);

  return (
    <div className="mb-3">
      <h2>Hi, {user?.username}</h2>
    </div>
  );
}

export default WelcomeNote;
